import { Skeleton } from "@/atoms/skeleton";

/**
 * The portal's wait, at the real geometry (spec skeleton 1.4).
 *
 * The 48 identity row, three section headings, two 64 subscription rows, two 52 card rows and
 * three 52 invoice rows: every block stands where its content will stand, so nothing moves when
 * the data lands.
 */

export function PortalSkeleton() {
  return (
    <div
      className="bg-surface-paper flex min-h-screen justify-center"
      aria-hidden="true"
    >
      <div className="px-gk-6 py-gk-4 sm:py-gk-8 gap-gk-6 flex w-full max-w-[640px] flex-col">
        <div className="ds-hairline gap-gk-4 pb-gk-6 flex items-center border-b">
          <Skeleton circle style={{ width: 48, height: 48 }} />
          <div className="gap-gk-2 flex flex-1 flex-col">
            <Skeleton style={{ width: "45%", height: 24 }} />
            <Skeleton style={{ width: "70%", height: 14 }} />
          </div>
        </div>

        <SkeletonSection headingWidth={140} rows={2} height={64} />
        <SkeletonSection headingWidth={180} rows={2} height={52} />
        <SkeletonSection headingWidth={100} rows={3} height={52} />
      </div>
    </div>
  );
}

function SkeletonSection({
  headingWidth,
  rows,
  height,
}: {
  headingWidth: number;
  rows: number;
  height: number;
}) {
  return (
    <div className="pt-gk-8 pb-gk-8 ds-hairline flex flex-col border-b last:border-b-0">
      <div className="mb-gk-4 flex min-h-[40px] items-center">
        <Skeleton style={{ width: headingWidth, height: 20 }} />
      </div>
      <div className="flex flex-col">
        {Array.from({ length: rows }, (_, row) => (
          <div
            key={row}
            className="flex items-center"
            style={{ minHeight: height }}
          >
            <Skeleton style={{ width: `${65 - row * 10}%`, height: 14 }} />
          </div>
        ))}
      </div>
    </div>
  );
}
